import React from "react";
import Page from "../../common/page/Page.js";
import SponsorshipBlock from "./SponsorshipBlock.js";
import useTranslationSponsorship from "../useTranslationSponsorship.js";
import useShowLoader from "../../common/loading-widgets/useShowLoader.js";

export default function SponsorshipPage() {

  const { t, loading: tLoading } = useTranslationSponsorship();
  useShowLoader(tLoading, "SponsorshipPage");

  return (
    <Page className="SponsorshipPage">
      <Page.Content className="spaced-children" title={t("sponsorship:sponsorship_landing_title")}>
        <SponsorshipBlock />
      </Page.Content>
    </Page>
  );
}
